/* eslint-disable no-useless-catch */
import createAuth0Client from '@auth0/auth0-spa-js';


export const createAuthOConnection = async (options) => {

  try {
    const auth0Config = {
      domain: options.provider,
      client_id: options.clientId,
      redirect_uri: options.redirectUri,
      scope: 'openid offline_access profile email'
    };

    return await createAuth0Client(auth0Config);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[OAuth] createAuth0Client error:', error);
    // Handle the error here
    throw error;
  }
};